export default "__VITE_ASSET__Bv4Nm4PQ__"